import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

const script = document.createElement('script');
script.src = 'https://cdn.jsdelivr.net/npm/eruda';
script.onload = () => {
  try {
    if (window.eruda && typeof window.eruda.init === 'function') {
      window.eruda.init();
    }
  } catch (e) {
    console.warn('eruda init skipped:', e);
  }
};
document.body.appendChild(script);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
